import React from 'react';
import { Link } from 'react-router-dom';
import useSeo from '../hooks/useSeo';
import './Pages.css';

function Consulting() {
  useSeo(
    'Consulting | Rev-Tech Cybersecurity & Technical Services',
    'Rev-Tech consulting services include cybersecurity advisory, audit readiness, DoD contract support, and technical project talent.',
    {
      ogTitle: 'Consulting | Rev-Tech Cybersecurity & Technical Services',
      ogDescription: 'Rev-Tech consulting services include cybersecurity advisory, audit readiness, DoD contract support, and technical project talent.',
      twitterTitle: 'Consulting | Rev-Tech Cybersecurity & Technical Services',
      twitterDescription: 'Rev-Tech consulting services include cybersecurity advisory, audit readiness, DoD contract support, and technical project talent.',
      canonical: 'https://www.rev-technology.com/consulting'
    }
  );

  return (
    <div className="page">
      <section className="hero">
        <h1>Consulting & Technical Services</h1>
        <p className="hero-copy">
          Rev-Tech delivers cybersecurity consulting, audit readiness support, DoD contract expertise, and specialized technical talent for complex projects.
          Our team helps organizations achieve stronger security posture and better project execution.
        </p>
        <Link to="/contact" className="cta-button large">Contact Us</Link>
      </section>

      <section className="content-section">
        <h2>What We Offer</h2>
        <p>
          Our consulting services are designed for businesses that need experienced advisors, compliance guidance, and skilled technical resources.
          We support cybersecurity assessments, audit preparation, contract requirements, and custom project work.
        </p>
      </section>

      <section className="content-section services-overview">
        <div className="service-overview-item">
          <h3>Cybersecurity Consulting</h3>
          <p>Risk assessments, security program planning, control implementation, and remediation support to protect your organization.</p>
        </div>
        <div className="service-overview-item">
          <h3>Audit Preparation</h3>
          <p>Focused readiness reviews, documentation support, and remediation planning for audits and compliance assessments.</p>
        </div>
        <div className="service-overview-item">
          <h3>DoD Contract Support</h3>
          <p>Assistance with compliance frameworks, security requirements, and contract-ready cybersecurity controls.</p>
        </div>
        <div className="service-overview-item">
          <h3>Technical Project Work</h3>
          <p>Specialized talent for infrastructure hardening, cloud migrations, secure deployments, and cybersecurity project delivery.</p>
        </div>
      </section>

      <section className="content-section benefits-section">
        <h2>Why Choose Rev-Tech Consulting</h2>
        <div className="benefits-list">
          <div className="benefit-item">
            <span className="benefit-icon">✓</span>
            <div className="benefit-text">
              <h4>Experienced Cybersecurity Advisors</h4>
              <p>Practical guidance for security, compliance, and technical execution.</p>
            </div>
          </div>
          <div className="benefit-item">
            <span className="benefit-icon">✓</span>
            <div className="benefit-text">
              <h4>Audit & Contract Readiness</h4>
              <p>Structured preparation for DoD, NIST, CMMC, and other regulatory requirements.</p>
            </div>
          </div>
          <div className="benefit-item">
            <span className="benefit-icon">✓</span>
            <div className="benefit-text">
              <h4>Technical Delivery</h4>
              <p>Skilled resources for project work, implementation, and secure infrastructure improvements.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="content-section cta-section">
        <h2>Ready to Strengthen Your Security?</h2>
        <p>Partner with Rev-Tech for expert consulting and technical support that helps you meet compliance requirements and deliver secure projects.</p>
        <Link to="/contact" className="cta-button large">Get Started Today</Link>
      </section>
    </div>
  );
}

export default Consulting;
